import {
  makeEnvironmentProviders,
  type EnvironmentProviders,
} from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { NotificationEffects } from './notification.effects';
import { reducer } from './notification.reducer';

export function provideNotificationState(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('notifications', reducer),
    provideEffects(NotificationEffects),
  ]);
}
